<template>
    <div class="challenge-results-stats">
        <div class="challenge-results-stats__correct">
            <div class="wr-stat-correct">
                <span class="challenge-results-stats__correct-icon"></span>
                <span class="challenge-results-stats__correct-label">DOĞRU</span>
            </div>
            <span class="challenge-results-stats__correct-value">x{{ statCorrect }}</span>
        </div>
        <div class="challenge-results-stats__incorrect">
            <div class="wr-stat-incorrect">
                <span class="challenge-results-stats__incorrect-icon"></span>
                <span class="challenge-results-stats__incorrect-label">YANLIŞ</span>
            </div>
            <span class="challenge-results-stats__incorrect-value">x{{ statIncorrect }}</span>
        </div>
        <div class="challenge-results-stats__skipped">
            <div class="wr-stat-skipped">
                <span class="challenge-results-stats__skipped-icon"></span>
                <span class="challenge-results-stats__skipped-label">GEÇİLEN</span>
            </div>
            <span class="challenge-results-stats__skipped-value">x{{ statSkipped }}</span>
        </div>
        <span class="challenge-results-stats__sound-waves"></span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            statCorrect: {
                type: Number,
                default: 4,
            },
            statIncorrect: {
                type: Number,
                default: 4,
            },
            statSkipped: {
                type: Number,
                default: 4,
            },
        },
    };
</script>

<style scoped src="@/css/components/challenge-results-stats.css"></style>